<template>
  <v-dialog v-model="open" persistent max-width="700">
    <v-card class="align-center text-center">
      <v-card-text>
        <h1 class="pt-5 text-left">Verificar Canhoto</h1>
        <div class="mt30"></div>
        <v-row justify="center">
          <v-col cols="12" md="9">
            <vue-upload-multiple-image
              :multiple="false"
              dragText="Selecione uma imagem"
              browseText="Arquivos .jpg ou .png"
              primaryText=""
              @upload-success="uploadImageSuccess1"
              @before-remove="beforeRemove1"
              @edit-image="editImage1"
              :data-images="images1"
            ></vue-upload-multiple-image>
          </v-col>
        </v-row>

        <div class="mt10"></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pb-5">
        <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
        <v-btn color="success" class="flex-grow-1" large @click="close()"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueUploadMultipleImage from 'vue-upload-multiple-image';

export default {
  name: 'Canhoto',
  components: {
    VueUploadMultipleImage
  },
  data: () => ({
    images1: []
  }),
  props: {
    open: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    beforeRemove1(index, done, fileList) {
      console.log('index', index, fileList);
      var r = confirm('Remover imagem?');
      if (r == true) {
        done();
      }
    },
    editImage1(formData, index, fileList) {
      console.log('Deseja editar a imagem?', formData, index, fileList);
    },
    uploadImageSuccess1(formData, index, fileList) {
      console.log('data', formData, index, fileList);
    },
    close() {
      this.$emit('closeCanhoto');
    }
  }
};
</script>

<style></style>
